// extracted by mini-css-extract-plugin
export var layoutContainer = "_dd-0";
export var layoutContainerNoRounding = "_dd-6";
export var layoutContainerOpen = "_dd-5";
export var layoutContainerResizing = "_dd-1";
export var mainContent = "_dd-2";
export var resizeDivider = "_dd-3";
export var slidePanel = "_dd-4";